var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("channel-selector", {
    class: { inactive: !_vm.isActive },
    attrs: { title: _vm.channel.name, src: _vm.getChannelThumbnail() },
    on: { click: _vm.onItemClick }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }